import { FormValidator } from '../../lib/FormValidator';

document.addEventListener('DOMContentLoaded', () => {
  if (!$('#page_my-register-learners_register_personal').is(':visible')) {
    return;
  }

  // For Register Personal page
  const definition = $('#validation_definition_holder').data(
    'validation-definition',
  );

  const rules = $.extend(true, definition.rules, {
    'user[last_name]': {
      remote:
        FormValidator.ajaxValidationParams.textValidation('user[last_name]'),
    },
    'user[first_name]': {
      remote:
        FormValidator.ajaxValidationParams.textValidation('user[first_name]'),
    },
    'user[gender_expression]': {
      remote: FormValidator.ajaxValidationParams.textValidation(
        'user[gender_expression]',
        'textarea',
        true,
        true,
      ),
    },
  });

  const validator = new FormValidator(
    $('#new_user'),
    rules,
    definition.messages,
  );
  const $selectFields = $(
    "select[name='user[aya_profile][grade_id]']" +
      ", select[name='user[aya_profile][birth_year]']" +
      ", select[name='user[aya_profile][birth_month]']" +
      ", select[name='user[aya_profile][birth_day]']",
  );
  validator.setValidation($selectFields);

  $('#submit').on('click', (e: JQuery.ClickEvent) => {
    // 下記リンクの事象を解決するため、pendingRequest が 0 より大きい場合、一瞬待ってから再度 submit している
    // https://github.com/quipper/aya-issues/issues/75811#issuecomment-2484517228
    if (validator.pendingRequest() > 0) {
      e.preventDefault();
      setTimeout(() => {
        $('#submit').trigger('click');
      }, 100);
      return false;
    } else {
      return true;
    }
  });

  // 選択された学年がtara_elementaryに該当する場合はタブレットに関する案内モーダルを表示する
  const handleSubmit = (e: JQuery.SubmitEvent): boolean => {
    if ($('form#new_user .error').length == 0) {
      const primaryAppKindByGradeIds = $('#primary-app-kind-holder').data(
        'primary-app-kind-by-grade-ids',
      );
      const selectedGradeId = $('#user_aya_profile_attributes_grade_id')
        .val()!
        .toString();
      if (primaryAppKindByGradeIds[selectedGradeId] == 'tara_elementary') {
        e.preventDefault();
        $('#tablet-info-modal').modal('show');
        return false;
      }
    }

    return true;
  };

  $('form#new_user').on('submit', handleSubmit);

  $('#tablet-info-modal #tablet-modal-confirmed').on(
    'change',
    (e: JQuery.ChangeEvent) => {
      if (e.target.checked) {
        $('.tablet-info-modal--submit-button--disabled').addClass('hidden');
        $('.tablet-info-modal--submit-button--active').removeClass('hidden');
      } else {
        $('.tablet-info-modal--submit-button--disabled').removeClass('hidden');
        $('.tablet-info-modal--submit-button--active').addClass('hidden');
      }
    },
  );

  $('#tablet-info-modal .tablet-info-modal--submit-button--active').on(
    'click',
    () => {
      $('form#new_user').off('submit', handleSubmit);
      $('#tablet-info-modal').modal('hide');
      $('form#new_user #submit').click();
    },
  );

  const $registerPersonalGenderRadio = $(
    'input[id^="register_personal_gender_radio"]',
  );
  const $genderRadioChecked = $registerPersonalGenderRadio.filter(':checked');
  const $genderExpressionWrapper = $(
    '#register_personal_gender_expression_wrapper',
  );
  const $genderExpressionNotice = $(
    '#register_personal_gender_expression_notice',
  );
  const $genderExpressionText = $('#user_gender_expression');

  if ($genderRadioChecked.length > 0) {
    $genderRadioChecked
      .closest('.gender-radio-card')
      .addClass('radio-card--checked');

    if ($genderRadioChecked.val() == 'free') {
      $genderExpressionWrapper.show();
      $genderExpressionNotice.show();
      $genderExpressionText.focus();
    } else {
      $genderExpressionWrapper.hide();
      $genderExpressionNotice.hide();
    }
  } else {
    $genderExpressionWrapper.hide();
    $genderExpressionNotice.hide();
  }

  let currentText = '';
  $genderExpressionText.on('blur', (e: JQuery.BlurEvent) => {
    currentText = $(e.target).val()!.toString();
  });

  $registerPersonalGenderRadio.on('change', (e: JQuery.ChangeEvent) => {
    const $gender = $(e.target);
    const $genderExpressionFormAlert = $('.alert-for-gender_expression');

    $('.radio-card--checked').removeClass('radio-card--checked');
    $gender.closest('.gender-radio-card').addClass('radio-card--checked');

    if ($gender.val() == 'free') {
      $genderExpressionWrapper.show();
      $genderExpressionNotice.show();
      $genderExpressionFormAlert.show();

      $genderExpressionText.val(currentText);
      $genderExpressionText.focus();
    } else {
      $genderExpressionWrapper.hide();
      $genderExpressionNotice.hide();
      $genderExpressionFormAlert.hide();
      $genderExpressionText.val('');
    }
  });

  $('.gender-radio-card').on('click', function () {
    $(this).find('input[type="radio"]').prop('checked', true).trigger('change');
  });
});

document.addEventListener('DOMContentLoaded', () => {
  // For Register Credential page
  if (!$('#page_my-register-learners_register_credential').is(':visible')) {
    return;
  }

  const definition = $('#validation_definition_holder').data(
    'validation-definition',
  );

  const validator = new FormValidator(
    $('#new_user'),
    definition.rules,
    definition.messages,
  );
  validator.setValidation();
});
